import {useMemo} from 'react'
import {Empty, Space, Table, Typography} from 'antd'
import {DeleteOutlined, EditOutlined} from '@ant-design/icons'
import EllipsisTooltip from '../../common/EllipsisTooltip'
import RecordsCount from '../../common/RecordsCount'
import TableActions from '../../common/TableActions'
import {useIntl} from 'react-intl'

const InlineConnectionTable = ({
  dataSource,
  pagination = false,
  getInlineConnectionsData = null,
  onEdit = null,
  onDelete = null,
}) => {
  const intl = useIntl()

  const columns = useMemo(
    () => [
      {
        title: (
          <EllipsisTooltip className="ellipsis">
            {intl.formatMessage({ id: 'inlineConnections.fromConnector' })}
          </EllipsisTooltip>
        ),
        dataIndex: 'from_connector_name',
        sorter: (a, b) => (a.from_connector_name || '').localeCompare(b.from_connector_name || ''),
        render: (text) => (
          <EllipsisTooltip className="ellipsis">
            {text || '-'}
          </EllipsisTooltip>
        ),
      },
      {
        title: (
          <EllipsisTooltip className="ellipsis">
            {intl.formatMessage({ id: 'inlineConnections.toConnector' })}
          </EllipsisTooltip>
        ),
        dataIndex: 'to_connector_name',
        sorter: (a, b) => (a.to_connector_name || '').localeCompare(b.to_connector_name || ''),
        render: (text) => (
          <EllipsisTooltip className="ellipsis">
            {text || '-'}
          </EllipsisTooltip>
        ),
      },
      {
        title: intl.formatMessage({ id: 'inlineConnections.suffix' }),
        width: '15%',
        render: (_, record) => (
          <EllipsisTooltip className="ellipsis">
            {record.from_suffix || '-'} / {record.to_suffix || '-'}
          </EllipsisTooltip>
        ),
      },
      {
        title: intl.formatMessage({ id: 'inlineConnections.prefix' }),
        width: '15%',
        render: (_, record) => (
          <EllipsisTooltip className="ellipsis">
            {record.from_prefix || '-'} / {record.to_prefix || '-'}
          </EllipsisTooltip>
        ),
      },
      {
        title: intl.formatMessage({ id: 'inlineConnections.action' }),
        align: 'right',
        width: 136,
        render: (_, record) => (
          <TableActions
            actions={[
              { key: 'edit', label: intl.formatMessage({ id: 'forms.edit' }), icon: <EditOutlined />, onClick: () => onEdit(record) },
              { key: 'delete', label: intl.formatMessage({ id: 'forms.delete' }), icon: <DeleteOutlined />, danger: true, onClick: () => onDelete(record.id) },
            ]}
          />
        ),
      },
    ],
    [dataSource, pagination]
  )

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{ width: '100%', verticalAlign: 'top' }}
    >
      <Table
        rowKey={(record) => `inline-connection-${record.id}`}
        columns={columns}
        dataSource={dataSource}
        showSorterTooltip={false}
        tableLayout='fixed'
        scroll={{
          x: dataSource.lenght > 0 ? 710 : undefined
        }}
        pagination={
          pagination
            ? {
                current: pagination?.currentPage,
                total: pagination?.totalCount,
                pageSize: 10,
                showSizeChanger: false,
                hideOnSinglePage: true,
                showTotal: (total) => <RecordsCount count={total} />,
                onChange: (page) => {
                  const offset = (page - 1) * 10
                  const url = pagination?.nextPageLink
                    ? new URL(pagination?.nextPageLink)
                    : new URL(pagination?.prevPageLink)
                  url.searchParams.set('offset', offset)
                  getInlineConnectionsData(url.toString())
                },
              }
            : false
        }
        locale={{
          emptyText: (
            <div style={{ padding: '40px' }}>
              <Empty description={<RecordsCount count={0} />} />
            </div>
          ),
        }}
      />
      {pagination && pagination?.totalPages <= 1 && pagination?.totalCount > 0 && (
        <Typography.Text>
          <RecordsCount count={pagination?.totalCount} />
        </Typography.Text>
      )}
    </Space>
  )
}

export default InlineConnectionTable
